<p-card header="Echo Graphs">
    <div class="grid">
        <div class="col">
            <p-card header="Rox For GEMM">
                <div *ngIf="loading" class="flex-1 p-4">
                    <p-progressSpinner></p-progressSpinner>
                </div>
                <p-chart *ngIf="!loading" type="line" [data]="roxData" [options]="options"></p-chart>
            </p-card>
        </div>
    </div>
</p-card>